<template>
  <div class="mt-3">
    <div class="section mb-2">
      <div class="section_header mb-3">
        <div class="row no-gutters align-items-center justify-content-between">
          <div class="col">
            <h2 class="section_header_title">
              {{ titulo }}
            </h2>
          </div>
        </div>
      </div>
    </div>
    
    <div class="container-fluid">
      <div class="row mt-3 gx-4">
        <div class="col-md-4">
          <label class="text-muted mb-1">Nome</label>
          <p><b>{{ arquivoEstruturado.nome || 'Não informado' }}</b></p>
        </div>

        <div class="col-md-2">
          <label class="text-muted mb-1">CPF</label>
          <p><b>{{ tratarDados('cpf', arquivoEstruturado.CPF) }}</b></p>
        </div>

        <div class="col-md-2">
          <label class="text-muted mb-1">Sexo</label>
          <p><b>{{ arquivoEstruturado.sexo || 'Não informado' }}</b></p>
        </div>
      </div>
    </div>

    <div class="container-fluid">
      <div class="row gx-4">
        <div class="col-md-2">
          <label class="text-muted mb-1">Data de nascimento</label>
          <p><b>{{ tratarDados('dataNascimento', arquivoEstruturado.data_nascimento) }}</b></p>
        </div>

        <div class="col-md-2">
          <label class="text-muted mb-1">Idade</label>
          <p><b>{{ arquivoEstruturado.idade || 'Não informado' }}</b></p>
        </div>

        <div class="col-md-2">
          <label class="text-muted mb-1">Tipo de idade</label>
          <p><b>{{ arquivoEstruturado.tipo_idade || 'Não informado' }} </b></p>
        </div>

        <div class="col-md-2">
          <label class="text-muted mb-1">Cor</label>
          <p><b>{{ tratarDados('cor', arquivoEstruturado.cor) }}</b></p>
        </div>

        <div class="col-md-2">
          <label class="text-muted mb-1">Estado civil</label>
          <p><b>{{ tratarDados('estadoCivil', arquivoEstruturado.estado_civil) }}</b></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Falecido',
    props: {
      arquivoEstruturado: {
        type: Object,
        default: null
      },
      titulo: {
        type: String,
        default: 'Falecido'
      }
    },
    methods: {
      tratarDados (tipo, dado) {
        if (!dado) return 'Não informado'

        switch (tipo) {
        case 'cpf':
          return this.formatarCpf(dado)
          
        case 'dataNascimento':
          return this.formatarData(dado)

        case 'cor':
          return this.formatarTexto(dado)

        case 'estadoCivil':
          return this.formatarTexto(dado)

        default:
          return dado
        }
      },
      formatarCpf (cpf) {
        cpf = cpf.toString().replace(/\D/g, '')

        if (cpf.length !== 11) return cpf

        return cpf.replace(
          /(\d{3})(\d{3})(\d{3})(\d{2})/,
          '$1.$2.$3-$4'
        )
      },
      formatarData (data) {
        return data.replace(/-/g, '/')
      },
      formatarTexto (texto) {
        return texto
          .toLowerCase()
          .replace(/\p{L}/u, letra => letra.toUpperCase())
      }
    }
  }
</script>

<style lang="scss" scoped>
@import "@/scss/_utilities/_exports";

.section {
  &_header {
    @extend %titleBox;
    background-color: $color-gray-light;

    &_title {
      @extend %titleBox_title;
    }
  }
}
.boxGenitor {
  box-shadow: 0 0 pxToRem(4) 0 $color-dark;

  &_error {
    border: solid 2px #8B0000;
    border-radius: 2px;
  }

  &_header {
    background-color: #01AEC9;
    color: $color-dark;

    &_title {
      font-size: pxToRem(14);
      font-weight: 500;
    }
  }

  &_body {
    border-right: 2px solid #DDDDDD;
    border-bottom: 2px solid #DDDDDD;
    border-radius: 0 0 8px 8px;
  }

  &_list {
    font-size: pxToRem(14);
    list-style: none;
    margin: 0;
    padding: 0;

    &_item {}

    &_title {
      margin-bottom: pxToRem(4);
      text-decoration: underline;
    }
  }
}
</style>